import React from 'react';
import { Typography } from '@mui/material';
import { isTimeBeforeTimeNow } from 'services/utils/dateCalculations';
import moment from 'moment-timezone';
import useShopFormat from 'hooks/useShopFormat';

interface OwnProps {
	returnTime: string | null;
	startDate: string | null;
}

type Props = OwnProps;

export const RentalCardReturnTime = ({ returnTime, startDate }: Props) => {
	const isLate = returnTime ? isTimeBeforeTimeNow(returnTime) : false;
	const { localFormat } = useShopFormat();
	const formattedReturnTime = returnTime ? localFormat(returnTime, 'ddd D.M., HH:mm') : '';

	const isRentalDurationZeroOrNull = () => {
		if (!startDate || !returnTime) {
			return true;
		}
		if (moment(startDate).isSame(moment(returnTime))) {
			return true;
		}
		return false;
	};

	return (
		<React.Fragment>
			{isRentalDurationZeroOrNull() ? (
				<div />
			) : (
				<React.Fragment>
					<Typography variant="body1" color={isLate ? 'error' : 'initial'} align="right">
						{formattedReturnTime}
					</Typography>
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

export default RentalCardReturnTime;
